import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import CircleCheckboxInput from 'components/Luxkit/Checkbox/CircleCheckboxInput'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import Group from 'components/utils/Group'
import { ItemMetadata } from 'tripPlanner/models'
import { ItemType } from 'tripPlanner/types/tripItem'
import { itemTypeToProductType } from 'tripPlanner/utils/summary'

const CardContent = styled(Group)`
  flex: 1;
  padding: ${rem(12)};
`

const Description = styled(Group)`
  flex-grow: 1;
`

const Selection = styled(Group)`
  width: ${rem(24)};
  height: ${rem(24)};
`

const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: ${rem(8)};
  gap: ${rem(10)};
  background-color: ${({ theme }) => theme.palette.neutral.default.six};
  width: ${rem(36)};
  height: ${rem(36)};
`
interface Props {
  title?: string
  type: ItemType
  onSelect: () => void
  isSelected: boolean
  image?: React.ReactNode
}

export function CuratedBaseItemSelection({
  title,
  type,
  onSelect,
  isSelected,
  image,
}: Props) {
  const Icon = ItemMetadata[type].icon
  return (
    <CardContent direction="horizontal" verticalAlign="center" gap={12}>
      {image || (
        <ImageContainer>
          <Icon />
        </ImageContainer>
      )}

      <Description direction="vertical" horizontalAlign="start">
        <BodyText variant="medium">{title}</BodyText>
        <Caption variant="medium" colour="neutral-three">
          {itemTypeToProductType[type]}
        </Caption>
      </Description>

      <Selection direction="horizontal" verticalAlign="end">
        <CircleCheckboxInput onClick={onSelect} checked={isSelected} />
      </Selection>
    </CardContent>
  )
}
